import { ButtonGroup, Button } from '@mui/material';
import { Assignment, Task } from '../types';

interface TaskSelectorProps {
    selectedTask: Task | undefined;
    setSelectedTask: (task: Task) => void;
    tasks: Task[];
    setTaskModalOpen: (open: boolean) => void;
    assignments: Assignment[];
}

const TaskSelector = (props: TaskSelectorProps) => {
    const { selectedTask, setSelectedTask, tasks, setTaskModalOpen, assignments } = props;

    const handleSelect = (id_task: number) => {
        if (tasks === undefined) return;
        let clickedTask = tasks.find((task) => task.id_task === id_task);
        if (clickedTask === undefined)
            return;

        if (selectedTask === undefined) {
            setSelectedTask(clickedTask);
            return;
        }

        if (clickedTask?.id_task === selectedTask.id_task) {
            setTaskModalOpen(true);
        } else {
            setSelectedTask(clickedTask);
        }
    };

    const hoursPerTask = assignments.reduce((acc, assignment) => {
        const hours = (assignment.end_time - assignment.start_time) / 3600;
        if (acc.has(assignment.id_task)) {
            acc.set(assignment.id_task, acc.get(assignment.id_task)! + hours);
        } else {
            acc.set(assignment.id_task, hours);
        }
        return acc;
    }, new Map<number, number>());

    return (
        <div style={{ flexWrap: "wrap", textAlign: "left" }}>
            {tasks.map((task) => {
                const selected = selectedTask!.id_task === task.id_task;
                const variant = selected ? 'contained' : 'outlined';
                const textColor = variant === 'contained' ? 'white' : task.color;
                const bgColor = variant === 'contained' ? task.color : 'white';
                const assignedHours = hoursPerTask.get(task.id_task!);
                return (
                    <ButtonGroup style={{
                        padding: "2px",
                    }}>
                        <Button
                            key={task.id_task}
                            onClick={() => handleSelect(task.id_task!)}
                            variant={variant}
                            style={{
                                backgroundColor: bgColor,
                                color: textColor,
                                borderColor: "black",
                                borderWidth: "1px",
                            }}
                        >
                            {task.name}
                        </Button>
                        {   assignedHours !== undefined && assignedHours > 0 &&
                            <Button
                                key={task.id_task}
                                variant={variant}
                                onClick={() => handleSelect(task.id_task!)}
                                style={{
                                    backgroundColor: bgColor,
                                    color: textColor,
                                    borderColor: "black",
                                    borderWidth: "1px",
                                    marginRight: "5px",
                                }}
                            >
                                {assignedHours}
                            </Button>
                        }
                    </ButtonGroup>
                )
            })}
        </div>
    );
};

export default TaskSelector;